import React from 'react';
import ConsultList from '../../components/consult/list/list';

export default () => {
    return <div><ConsultList/></div>
}